// import Butter from 'buttercms';
import React from 'react';

import PageLayout from '../../../components/PageLayout';

import BlogPost from './BlogPost';

// const butter = Butter('097e06709f9ffb080698a9c8045e5af1f81bdf55');

async function action(context) {
  const { blogSlug } = context.params;

  // const resp = await butter.post.retrieve(blogSlug);

  // const { data } = resp.data;

  return {
    title: "Flux Tech's Blog Post",
    description:
      'Flux Tech is a company with a passion for everything startups; the technology, the business models, the energy. And, our blog is were we get to talk about that.',
    chunks: ['blog-post'],
    component: (
      <PageLayout>
        <BlogPost /* blogData={data} */ />
      </PageLayout>
    ),
  };
}

export default action;
